import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let NotificationComponent = class extends Mixins(MagicConfigMixin) {
  mounted() {
    this.contentChanged();
  }
  contentChanged() {
    const contentElement = this.$refs.content;
    if (typeof this.content === "string") {
      contentElement.innerHTML = this.content;
    } else if (this.content) {
      while (contentElement.firstChild) {
        contentElement.removeChild(contentElement.firstChild);
      }
      contentElement.appendChild(this.content);
    }
  }
  close() {
    return;
  }
  get iconVariant() {
    switch (this.variant) {
      case "info":
        return "info-solid";
      case "success":
        return "tick-solid";
      case "alert":
        return "alert-solid";
      case "error":
        return "close-solid";
      case "cookie":
        return "no-icon";
      default:
        return "icon-content";
    }
  }
  get iconToastVariant() {
    switch (this.variant) {
      case "info":
        return "info";
      case "success":
        return "checked";
      case "alert":
        return "alert";
      case "error":
        return "close-circle";
      case "cookie":
        return "no-icon";
      default:
        return "icon-content";
    }
  }
  get isNotMessage() {
    return this.variant !== "message" && this.variant !== "cookie";
  }
};
__decorateClass([
  Prop(Boolean)
], NotificationComponent.prototype, "dismissible", 2);
__decorateClass([
  Prop({ type: [String, Element], default: null })
], NotificationComponent.prototype, "content", 2);
__decorateClass([
  Prop(String)
], NotificationComponent.prototype, "variant", 2);
__decorateClass([
  Prop({
    type: String
  })
], NotificationComponent.prototype, "uniqueId", 2);
__decorateClass([
  Prop(Boolean)
], NotificationComponent.prototype, "isToastNotification", 2);
__decorateClass([
  Prop(String)
], NotificationComponent.prototype, "progressVariant", 2);
__decorateClass([
  Watch("content")
], NotificationComponent.prototype, "contentChanged", 1);
__decorateClass([
  Emit("close")
], NotificationComponent.prototype, "close", 1);
NotificationComponent = __decorateClass([
  Component({
    name: "ui-notification"
  })
], NotificationComponent);

export default NotificationComponent;
